export interface IOuter {
  dataHook: string;
}

export enum MediaHomeEditService {
  PhotoStudio = 'photo-studio',
  VideoMaker = 'video-maker',
}
